import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { collection, doc, getDoc, getDocs, query, where, setDoc, deleteField, collectionGroup, serverTimestamp } from "firebase/firestore"; 
import { db } from "../firebase";

import { useEffect, useState } from "react";
import GameLoader from "../components/gametools/GameLoader";

import JumperGame from "../components/games/JumperGame";
import PlatformerGame from "../components/games/PlatformerGame";
import RunnerGame from "../components/games/RunnerGame";
import MazerGame from "../components/games/MazerGame";
import SwimmerGame from "../components/games/SwimmerGame";
import InvaderGame from "../components/games/InvaderGame";
import RacerGame from "../components/games/RacerGame";
import PopperGame from "../components/games/PopperGame";
import TestGame from "../components/games/TestGame";

const GameRoom = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const inputId = searchParams.get('gameId');

  const navigate = useNavigate();

  const [userData, setUserData] = useState();
  const [gameData, setGameData] = useState();
  const [scoreData, setScoreData] = useState();
  const [currentGameId, setCurrentGameId] = useState(inputId);
  const [allGamesArray, setAllGamesArray] = useState([]);
  const [reloadGame, setReloadGame] = useState(false);
  const [startedGame, setStartedGame] = useState(false);
  const [userGamesData, setUserGamesData] = useState();

  useEffect(() => {
    const fetchData = async () => {
      if(currentGameId !== null){
        const userId = currentGameId.substring(0, 10);
        const gameId = currentGameId.substring(11, 17);
    
        const userRef = doc(db, "users", userId);
        const userSnap = await getDoc(userRef);
    
        const gameRef = doc(db, "users", userId, "games", gameId);
        const gameSnap = await getDoc(gameRef);

        const scoreRef = doc(db, "highscore", userId + "_" + gameId);
        const scoreSnap = await getDoc(scoreRef);

        if(scoreSnap.exists()){
          console.log("Set Score Exist");
          console.log(scoreSnap.data());
          setScoreData(scoreSnap.data());
        }
        else{
          console.log("Set Score No Exist");
          setScoreData({});
        }
  
        if(userSnap !== null && gameSnap !== null){
          setUserData(userSnap.data());
          setGameData(gameSnap.data());

          const userGamesCol = collection(db, "users", userId, "games");
          const publishedGamesQuery = query(
            userGamesCol,
            where("publish", "==", true)
          );
          const userGamesSnap = await getDocs(publishedGamesQuery);

          const myGames = [];
          userGamesSnap.forEach(doc => {
            // you might want to keep the doc.id as gameId
            const data = doc.data();
            data.gameId = doc.id;
            myGames.push(data);
          });

          setUserGamesData(myGames);

          if(!startedGame){
            if(gameSnap.data().gameType === "jumper"){
              navigate("/gameroom/jumper?gameId=" + currentGameId);
              setStartedGame(true);
            }
            else if(gameSnap.data().gameType === "platformer" || gameSnap.data().gameType === "platformer_xl"){
              navigate("/gameroom/platformer?gameId=" + currentGameId);
              setStartedGame(true);
            }
            else if(gameSnap.data().gameType === "runner"){
              navigate("/gameroom/runner?gameId=" + currentGameId);
              setStartedGame(true);
            }
            else if(gameSnap.data().gameType === "mazer"){
              navigate("/gameroom/mazer?gameId=" + currentGameId);
              setStartedGame(true);
            }
            else if(gameSnap.data().gameType === "swimmer"){
              navigate("/gameroom/swimmer?gameId=" + currentGameId);
              setStartedGame(true);
            }
            else if(gameSnap.data().gameType === "invader"){
              navigate("/gameroom/invader?gameId=" + currentGameId);
              setStartedGame(true);
            }
            else if(gameSnap.data().gameType === "racer"){
              navigate("/gameroom/racer?gameId=" + currentGameId);
              setStartedGame(true);
            }
            else if(gameSnap.data().gameType === "popper"){
              navigate("/gameroom/popper?gameId=" + currentGameId);
              setStartedGame(true);
            }
            else if(gameSnap.data().gameType === "testgame"){
              navigate("/gameroom/testgame?gameId=" + currentGameId);
              setStartedGame(true);
            }
          }
        }
      }
      else{
        try {
          const gamesCollectionRef = collectionGroup(db, "games");
          const gamesQuerySnapshot = await getDocs(gamesCollectionRef);
      
          const games = [];
      
          gamesQuerySnapshot.forEach((gameDoc) => {
              const gameData = gameDoc.data();
              if (gameData.publish === true && gameData.gameVersion >= 3) {
                gameData.userId = gameDoc.ref.parent.parent.id
                games.push(gameData);
              }
          });
      
          setAllGamesArray(games);
          return games;
        } catch (error) {
            console.error("Error fetching published games:", error);
            return [];
        }
      }
    };
  
    fetchData();
  }, [currentGameId, reloadGame, location]);

  const handleCardClick = (gameId) =>{
    setReloadGame(!reloadGame)
    setCurrentGameId(gameId);
  }

  const clearData = () =>{
    setUserData(undefined);
    setGameData(undefined);
    setCurrentGameId(null);
    setStartedGame(false);
    setScoreData(null);
  }

const handleNewHighScore = async (highScoreData) => {
  const { scoreId, name, location, score } = highScoreData;
  const scoreRef = doc(db, "highscore", gameData.userId + "_" + gameData.gameId);

  // Fetch the current score data from Firestore
  const scoreSnap = await getDoc(scoreRef);

  let currentHighScores = {};

  if (scoreSnap.exists()) {
    currentHighScores = scoreSnap.data();
  } else {
    console.log("No existing score data found — starting fresh.");
  }

  // Add the new score to the existing scoreData
  currentHighScores[scoreId] = {
    scoreId,
    name,
    score,
    location,
    timestamp: serverTimestamp(),
  };

  // Sort the scores in descending order based on the score
  const sortedScores = Object.values(currentHighScores).sort((a, b) => b.score - a.score);

  // If the number of high scores exceeds 5, remove the lowest one
  if (sortedScores.length > 5) {
    const removedScore = sortedScores.pop();  // Remove the last (lowest) score
    console.log("Removed score:", removedScore);  // Log the removed score for debugging

    // Delete the removed score from Firestore using the scoreId
    const removedScoreId = removedScore.scoreId;
    await setDoc(scoreRef, {
      [removedScoreId]: deleteField(),  // Delete the score with the specific scoreId
    }, {merge: true});
  }

  // Only update the newly added score in Firestore (as a single field)
  await setDoc(scoreRef, {
    [scoreId]: {
      scoreId,
      name,
      score,
      location,
      timestamp: serverTimestamp(),
    }
  }, {merge: true});

  const snap2 = await getDoc(scoreRef);
  setScoreData(snap2.data());
};


  return (
      <Routes>
        <Route path="/" element={
            <GameLoader 
              allGamesArray={allGamesArray}
              handleCardClick={handleCardClick}
              clearData={clearData}
            />} 
        />
        <Route path="/jumper" element={
            <JumperGame
              userData={userData}
              gameData={gameData}
              scoreData={scoreData}
              clearData={clearData}
              handleNewHighScore={handleNewHighScore}
              userGamesData={userGamesData}
            />} 
        />
        <Route path="/platformer" element={
          <PlatformerGame
              userData={userData}
              gameData={gameData}
              scoreData={scoreData}
              clearData={clearData}
              handleNewHighScore={handleNewHighScore}
              userGamesData={userGamesData}
          />} 
        />
        <Route path="/runner" element={
          <RunnerGame
            userData={userData}
            gameData={gameData}
            scoreData={scoreData}
            clearData={clearData}
            handleNewHighScore={handleNewHighScore}
            userGamesData={userGamesData}
          />} 
        />

        <Route path="/mazer" element={
          <MazerGame
              userData={userData}
              gameData={gameData}
              scoreData={scoreData}
              clearData={clearData}
              handleNewHighScore={handleNewHighScore}
              userGamesData={userGamesData}
          />} 
        />

        <Route path="/swimmer" element={
          <SwimmerGame
            userData={userData}
            gameData={gameData}
            clearData={clearData}
          />} 
        />

        <Route path="/invader" element={
          <InvaderGame
            userData={userData}
            gameData={gameData}
            scoreData={scoreData}
            clearData={clearData}
            handleNewHighScore={handleNewHighScore}
            userGamesData={userGamesData}
          />} 
        />

        <Route path="/racer" element={
          <RacerGame
            userData={userData}
            gameData={gameData}
            clearData={clearData}
          />} 
        />

        <Route path="/popper" element={
          <PopperGame
            userData={userData}
            gameData={gameData}
            clearData={clearData}
          />} 
        />

        <Route path="/testgame" element={
          <TestGame
            userData={userData}
            gameData={gameData}
            clearData={clearData}
          />} 
        />

      </Routes>
  );
}

export default GameRoom;